// src/redux/catalogs/states/citiesSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICompany } from "../../../interfaces/models/ICompany";

const initialState: ICompany[] = [];

export const companiesSlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    SetCompanies: (_, action: PayloadAction<ICompany[]>) => action.payload,
    AddCompany: (state, action: PayloadAction<ICompany>) => {
      state.push(action.payload);
    },
    UpdateCompany: (state, action: PayloadAction<ICompany>) => {
      const index = state.findIndex((company) => company.id === action.payload.id);
      if (index !== -1) {
        state[index] = { ...state[index], ...action.payload };
      }
    },
    DeleteCompany: (state, action: PayloadAction<string>) => {
      return state?.filter((company) => company.id !== action.payload);
    },
  },
});

export const { SetCompanies, AddCompany, UpdateCompany, DeleteCompany } =
  companiesSlice.actions;
export default companiesSlice.reducer;
